<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/storage-step1')"></span>
    </div>
    <div class="title">请选择仓储套餐</div>
    <img class="promo-image" src='../../assets/img/storage/cangchu.png'>
    <br>
    <div class="main">
      <div class="btn-long no-margin-top" @click="choosePlan('1668743923')">
        <div class="col1">
          <div class="col1-row1">Mini 套餐</div>
          <div class="col1-row2"><span class="color-orange">5 </span>件行李以内</div>
        </div>
        <div class="col1">
          <div class="col2-row1">特惠价: <span class="col-price">$298</span></div>
          <!-- <div class="col2-row2">原价: $355</div> -->
          <div class="col2-row3"><span class="color-orange">免费赠送</span>上门取件+送回<br>寄存3个月</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
      </div>


      <div class="btn-long" @click="choosePlan('1668743953')">
        <div class="col1">
          <div class="col1-row1">A套餐</div>
          <div class="col1-row2"><span class="color-orange">10 </span>件行李以内</div>
        </div>
        <div class="col1">
          <div class="col2-row1">特惠价: <span class="col-price">$428</span></div>
          <!-- <div class="col2-row2">原价: $550</div> -->
          <div class="col2-row3"><span class="color-orange">免费赠送</span>上门取件+送回<br>寄存3个月</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
      </div>

      <div class="btn-long" @click="choosePlan('1668743985')">
        <div class="col1">
          <div class="col1-row1">B套餐</div>
          <div class="col1-row2"><span class="color-orange">15 </span>件行李以内</div>
        </div>
        <div class="col1">
          <div class="col2-row1">特惠价: <span class="col-price">$568</span></div>
          <!-- <div class="col2-row2">原价: $795</div> -->
          <div class="col2-row3"><span class="color-orange">免费赠送</span>上门取件+送回<br>寄存3个月</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
      </div>

      <div class="btn-long" @click="choosePlan('1668744048')">
        <div class="col1">
          <div class="col1-row1">C套餐</div>
          <div class="col1-row2"><span class="color-orange">20 </span>件行李以内</div>
        </div>
        <div class="col1">
          <div class="col2-row1">特惠价: <span class="col-price">$688</span></div>
          <!-- <div class="col2-row2">原价: $970</div> -->
          <div class="col2-row3"><span class="color-orange">免费赠送</span>上门取件+送回<br>寄存3个月</div>

        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
      </div>

    </div>
    <img :src="pixelURL('cangchu','step2')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step1',
  data () {
    return {
      order:{
        service:'storage',
        data:{
          username:"",
          userphone:"",
          pick_date:"",
          return_date:"",
          pick_period:"",
          return_period:"",
          baggage: 10,
          student_plan:'',
          pick_street: "",
          pick_suburb: "",
          pick_state: "NSW",
          pick_postcode: "",
          return_street: "",
          return_suburb: "",
          return_state: "NSW",
          return_postcode: "",
          agency: "",
          return_pending:"",
          msg:"",
          coupon:"",
          couponLocked:"",
          couponValue:0,
        },
      },
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "storage"){
        this.order = localParsed;
      }
      else{
        // this.$router.push('/');
      }
    }
    else{
      // this.$router.push('/');
    }
  },
  methods: {
    choosePlan(id){
      //配置当前套餐的max 最大行李数
      let max = '';
      switch (id) {
        case "1668743923":
          max = 5
          break;
        case "1668743953":
          max = 10
          break;
        case "1668743985":
          max = 15
          break;
        case "1668744048":
          max = 20
          break;
        default:
          console.log("1");
      }
      //如果当前缓存的行李数，大于新选套餐的最大行李数，则用后者覆盖前者
      if(this.order.data.baggage>max){
        this.orderUpdate('baggage',max);
      }
     
      else{
         //如果当前的max是5（mini套餐），则将max设为6（在后续代码，max-5后，推荐的行李数就等于1）
        if(max-5<=0){
	        max = 6;
        }
        //选择了套餐后，默认给它的行李数等于套餐最大值-5
        this.orderUpdate('baggage',max-5);
      }
      this.orderUpdate('student_plan',id,'/storage-intro')
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn-long{
  width: 85%;
  height: 112px;
  cursor: pointer;
  display: flex;
  justify-content:space-around;
  align-items: center;
  border-radius: 5px;
  font-size: 1.1em;
  margin: 0 auto;
  margin-top: 20px;
  padding-left:6vw;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
  background: #fff;
  border:1px solid #e3e3e3;
  -webkit-box-shadow: 0 10px 16px -10px rgba(0,0,0,0.1);
  -moz-box-shadow: 0 10px 16px -10px rgba(0,0,0,0.1);
  box-shadow: 0 10px 16px -10px rgba(0,0,0,0.1);
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}


.no-margin-top{
  margin-top:0;
}

.promo-image{
  width:80%;
  margin:6px auto;
  display:block;
  
}

.col1{
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}

.col1-row1{
  color:#555;
  line-height:1;
  font-size:1.1em;
}
.col1-row2{
  // border:1px solid #ff7444;
  // padding:0px 5px;
  border-radius:3px;
  font-size:0.7em;
  font-weight:200;
  color:#999;
  display:inline-block;
}

.col2-row1{
  text-align:right;
  font-size:0.8em;
  color:#666;
}

.col2-row2{
  text-decoration:line-through;
  color:#999;
  font-size:0.7em;
  text-align:right;
  margin-top:2px;
  margin-bottom:2px;
  font-weight:200;
}

.col2-row3{
  color:#666;
  font-size:0.7em;
  text-align:right;
  margin-top:2px;
  margin-bottom:2px;
  font-weight:200;
}

.col-3{
  font-size:2em;
  color:#ccc;
  padding:0 6px;
}

.col-price{
  color:#ff7444;
  font-size:1.4em;
}
</style>



// WEBPACK FOOTER //
// src/pages/storage/step2.vue